import { useState, useEffect } from "react";
import * as Scrivito from "scrivito";
import { isBrowser } from "^/utils/isBrowser";
import "./columnContainerWidget.scss";
import Carousel from "react-bootstrap/Carousel";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

Scrivito.provideComponent("ColumnContainerWidget", ({ widget }) => {
  const columns = widget.get("columns");
  const options = widget.get("options") || [];
  const asMobileSlider = options.includes("asMobileSlider");
  const optionClasses = options.filter((o) => o !== "asMobileSlider");
  const classNames = [...optionClasses, "row"];
  const [asSlider, setAsSlider] = useState(
    isBrowser && asMobileSlider && window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setAsSlider(asMobileSlider && window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => handleResize();
  }, [asMobileSlider]);

  if (!columns.length) {
    return (
      <InPlaceEditingPlaceholder center>
        Define columns in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  if (asSlider) {
    return (
      <Carousel
        controls={true}
        indicators={true}
        interval={null}
        className={`${classNames.join(" ")} column-widget-slider`}
      >
        {columns.map((col, index) => (
          <Carousel.Item key={index}>
            <Scrivito.ContentTag
              content={col}
              attribute="content"
              className="h-100"
            />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }

  const content = columns.map((columnWidget, index) => {
    const colSize = columnWidget.get("colSize") || 1;
    return (
      <div
        key={index}
        className={`col-lg-${colSize} mb-${
          index + 1 < columns.length ? "4" : "0"
        } mb-lg-0`}
      >
        <Scrivito.ContentTag
          content={columnWidget}
          attribute="content"
          className="h-100"
        />
      </div>
    );
  });

  if (widget.get("alignment")) {
    classNames.push(`align-items-${widget.get("alignment")}`);
  } else {
    classNames.push("align-items-start");
  }

  return <div className={classNames.join(" ")}>{content}</div>;
});
